<template>
  <div class="filter-container">
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-6 py-1">
        <custom-dropdown
          v-model="selectedYear"
          placeholder="Seleccione el año"
          fieldkey="id"
          fieldname="description"
          :options="academicyears"
          :clearable="true"
          @input="onChangeAcademicYear"
        />
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 py-1">
        <ValidationObserver ref="filterTextObserver">
          <ValidationProvider
            v-slot="{ errors }"
            class="w-100"
            name="razón de referido"
            :rules="isFilterTextNeeded"
          >
            <custom-input
              v-model="filterText"
              placeholder="Escriba Número de SIE, Nombre de Estudiante o Número de Registro"
              left-icon
              icon="fa fa-search orange-icon"
              :error="errors[0]"
            />
          </ValidationProvider>
        </ValidationObserver>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-12 py-1">
        <action-button
          text="Buscar"
          variant="success"
          class="fr ml-4 px-4 mb-2"
          @click="eventHandle(search, search)"
        />
        <action-button
          v-if="!simple"
          i="fal fa-sliders-v"
          variant="orange"
          class="fr mr-2 pl-3"
          :class="{ transparent: !isAdvancedFiltering }"
          @click="onAdvancedFilter"
        />
      </div>
    </div>

    <div v-if="!simple && isAdvancedFiltering && selectedYear">
      <div class="row py-3">
        <div class="col-12">
          <span class="separator">FILTROS</span>
        </div>
      </div>

      <div class="row pl-2 pr-2">
        <div class="col-12 col-sm-6 col-md-3 pt-0">
          <custom-dropdown
            v-model="selectedService"
            label="Servicio:"
            fieldkey="id"
            fieldname="name"
            :options="services"
            :clearable="false"
            :default-value="this.defaultValue"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-3 pt-0">
          <custom-dropdown
            v-model="selectedDiscipline"
            label="Disciplina:"
            fieldkey="id"
            fieldname="name"
            :options="disciplines"
            :clearable="false"
            :default-value="this.defaultValue"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-3 pt-0">
          <custom-dropdown
            v-model="selectedStatus"
            label="Estatus:"
            fieldkey="id"
            fieldname="name"
            :options="statuses"
            :clearable="false"
            :default-value="this.defaultValue"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-3 pt-0">
          <custom-dropdown
            v-model="selectedCenter"
            label="Centro:"
            fieldkey="id"
            fieldname="name"
            :options="centers"
            :clearable="false"
            :default-value="this.defaultValue"
            @input="onChangeCenters"
          />
        </div>
      </div>

      <div class="row pl-2 pr-2 pt-2">
        <div class="col-12 col-sm-6 col-md-3">
          <custom-dropdown
            v-model="selectedRegion"
            label="Región:"
            fieldkey="id"
            fieldname="name"
            :options="regions"
            :clearable="false"
            @input="onChangeRegion"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <custom-dropdown
            v-model="selectedMunicipality"
            label="Municipio:"
            fieldkey="id"
            fieldname="name"
            :options="municipalities"
            :clearable="false"
            @input="onChangeMunicipalities"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <custom-dropdown
            v-model="selectedSchool"
            label="Escuela:"
            fieldkey="id"
            fieldname="name"
            :options="schools"
            :clearable="false"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-3 offset-0 pt-1">
          <label>Ordenar por Fecha:</label>
          <CustomRadioGroup
            v-model="orderBy"
            :options="radioButtonsOptions"
            :name="'wasInvited'"
            :is-inline="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropdown from "@/components/common/CustomDropDown";
import CustomInput from "@/components/common/CustomInput";
import ActionButton from "@/components/common/ActionButton";
import CustomRadioGroup from "@/components/common/CustomRadio";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import alert from "@/mixin/alert.mixin";
import loading from "@/mixin/loading.mixin";

import { modulesName } from "@/modules";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters, mapActions } = createNamespacedHelpers(
  modulesName.StudentEvalutionRequestManagmentModuleName
);

export default {
  name: "FilterRequestManagement",
  components: {
    CustomDropdown,
    CustomInput,
    ActionButton,
    CustomRadioGroup,
    ValidationProvider,
    ValidationObserver
  },
  mixins: [alert, loading],
  props: {
    simple: {
      type: Boolean,
      default: () => false
    },
    search: {
      type: String,
      default: "",
      required: false
    }
  },
  data() {
    return {
      defaultValue: {
        id: null,
        name: "Todos",
        selected: true
      },
      orderByValues: {
        default: "-1",
        asc: "1",
        desc: "2"
      },
      isAdvancedFiltering: false,
      selectedYear: null,
      filterText: "",
      selectedService: {},
      selectedDiscipline: null,
      selectedStatus: null,
      selectedCenter: null,
      selectedRegion: null,
      selectedMunicipality: null,
      selectedSchool: null,
      orderBy: null,
      radioButtonsOptions: [
        { label: "Ascendente", value: "1" },
        { label: "Descendente", value: "2" }
      ]
    };
  },
  async mounted() {
    this.resetFilters(); //Set default values
    this.getFilters({ isAdvanced: false });
    //Valid current filters
    if (this.currentFilters.selectedYear != null) {
      this.selectedYear = this.currentFilters.selectedYear;
      this.filterText = isNaN(this.currentFilters.studentSie)
        ? this.currentFilters.searchText
        : this.currentFilters.studentSie;

      this.selectedService = this.currentFilters.selectedService;
      this.selectedDiscipline = this.currentFilters.selectedDiscipline;
      this.selectedStatus = this.currentFilters.selectedStatus;
      this.selectedCenter = this.currentFilters.selectedCenter;
      this.selectedRegion = this.currentFilters.selectedRegion;
      this.selectedMunicipality = this.currentFilters.selectedMunicipality;
      this.selectedSchool = this.currentFilters.selectedSchool;
      this.orderBy = this.currentFilters.orderBy;
      this.isAdvancedFiltering = this.currentFilters.isAdvancedFiltering;
    }
  },
  computed: {
    hasRegionAccessLevel() {
      return this.$store.getters.HasPermission("level.region");
    },
    hasCenterAccessLevel() {
      return this.$store.getters.HasPermission("level.center");
    },
    hasSchoolAccessLevel() {
      return this.$store.getters.HasPermission("level.school");
    },
    hasMunicipalyAccessLevel() {
      return this.$store.getters.HasPermission("level.municipality");
    },
    isFilterTextNeeded() {
      let validation = this.selectedYear ? "" : "required";
      return validation;
    },
    ...mapState({
      academicyears: state => state.filters.academicYears,
      services: state => state.filters.services,
      disciplines: state => state.filters.disciplines,
      statuses: state => state.filters.statuses,
      centers: state => state.filters.centers,
      regions: state => state.filters.regions,
      municipalities: state => state.filters.municipalities,
      schools: state => state.filters.schools
    }),
    ...mapGetters({
      currentFilters: "getCurrentFilters"
    })
  },
  watch: {
    academicyears() {
      if (this.selectedYear == null && this.academicyears.length > 0) {
        let AcademicYearId = this.currentAcademicYear().id;

        this.selectedYear = this.academicyears.find(
          f => f.id == AcademicYearId
        );
        this.getCenters({ AcademicYearId: AcademicYearId });
      }
    },
    regions() {
      if (this.selectedRegion == null && this.regions.length == 1) {
        this.selectedRegion = this.regions[0];
        this.getMunicipalities({
          AcademicYearId: this.selectedYear.id,
          RegionId: this.selectedRegion.id
        });
      }
    },
    municipalities() {
      if (
        this.selectedMunicipality == null &&
        this.municipalities.length == 1
      ) {
        this.selectedMunicipality = this.municipalities[0];
        this.getSchools({
          RegionId: this.selectedRegion.id,
          AcademicYearId: this.selectedYear.id,
          MunicipalityId: this.selectedMunicipality.id
        });
      }
    },
    schools() {
      if (this.selectedSchool == null && this.schools.length == 1) {
        this.selectedSchool = this.schools[0];
      }
    }
  },
  methods: {
    ...mapActions({
      getFilters: "getFilters",
      getCenters: "getCenters",
      getRegions: "getRegions",
      getMunicipalities: "getMunicipalities",
      getSchools: "getSchools"
    }),
    eventHandle: async function(action, parameter) {
      const isValid = await this.$refs.filterTextObserver.validate();
      if (isValid && action !== undefined) {
        this.$emit(action, parameter);
      }
    },
    onAdvancedFilter() {
      this.isAdvancedFiltering = !this.isAdvancedFiltering;
      if (this.isAdvancedFiltering) {
        //Reset All Filters Selected
        this.resetFilters();
        this.getFilters({
          isAdvanced: this.isAdvancedFiltering
        });
      }
    },
    resetFilters() {
      this.selectedService = this.defaultValue;
      this.selectedDiscipline = this.defaultValue;
      this.selectedStatus = this.defaultValue;
      const selectCenter = this.centers.find(f => f.selected);

      if (!selectCenter) {
        this.selectedCenter = this.defaultValue;
      } else {
        this.selectedCenter = selectCenter;
      }
      if (this.selectedYear) {
        this.getRegions({
          AcademicYearId: this.selectedYear.id,
          CenterId: this.selectedCenter.id
        });
      }
      this.orderBy = this.orderByValues.default;
    },
    async onChangeAcademicYear() {
      if (this.regions.length > 1) {
        this.selectedRegion = null;
      }
      if (this.municipalities.length > 1) {
        this.selectedMunicipality = null;
      }
      if (this.schools.length > 1) {
        this.selectedSchool = null;
      }
      this.regions = null;
      if (this.selectedYear && this.centers.length > 1) {
        this.selectedCenter = null;
        this.getCenters({ AcademicYearId: this.selectedYear.id });
      }
    },

    async onChangeCenters() {
      this.selectedRegion = null;
      this.selectedMunicipality = null;
      this.selectedSchool = null;

      this.municipalities = [];
      this.schools = [];

      this.getRegions({
        AcademicYearId: this.selectedYear.id,
        CenterId: this.selectedCenter.id
      });
    },
    async onChangeRegion() {
      this.selectedMunicipality = null;
      this.selectedSchool = null;

      this.getMunicipalities({
        AcademicYearId: this.selectedYear.id,
        RegionId: this.selectedRegion.id
      });
    },
    async onChangeMunicipalities() {
      this.selectedSchool = null;
      this.getSchools({
        RegionId: this.selectedRegion.id,
        AcademicYearId: this.selectedYear.id,
        MunicipalityId: this.selectedMunicipality.id
      });
    }
  }
};
</script>

<style scoped>
.filter-container {
  background-color: #f4f6f3;
  padding: 15px;
}
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #aab7b1;
  font: 900 14px/17px Lato;
}
.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #aab7b1;
}
.separator::before {
  margin-right: 0.5em;
}
.separator::after {
  margin-left: 0.5em;
}
</style>
